class SiteMsgSlider extends HTMLElement {
  constructor() {
    super();
    this._listeners = []; 
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this._listeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler);
    });
    this._listeners = [];

    if (this._swiper && this._swiper.destroy) {
      try {
        this._swiper.destroy(true, true);
      } catch (err) {
        console.warn('[SiteMsgSlider] failed to destroy Swiper:', err);
      }
      this._swiper = null;
    }
  }

  init() {
    const sliderEl = this.querySelector('.swiper');
    if (!sliderEl) return;

    const currentBrand = this.dataset.brand || '';
    const key = `site_msg_hidden_until_${currentBrand}`;

    const hiddenUntil = localStorage.getItem(key);
    if (hiddenUntil && new Date() < new Date(hiddenUntil)) {
      this.style.display = 'none';
      return;
    }

    this.initSwiper(sliderEl);

    this.querySelectorAll('.site-msg-close').forEach((btn) => {
      const handler = () => this.hideForDuration(key, 30);
      btn.addEventListener('click', handler);
      this._listeners.push({ element: btn, event: 'click', handler });
    });
  }

  initSwiper(sliderEl) {
    try {
      if (typeof swiperManager !== 'undefined') {
        this._swiper = new swiperManager('.swiper-container-top-bar', {
          onlyMobile: false,
          swiper: {
            slidesPerView: 1,
            loop: true,
            speed: 800,
            autoplay: {
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            },
            navigation: {
              // nextEl: '.swiper-button-next',
              // prevEl: '.swiper-button-prev',
            },
            pagination: false,
          },
        });
      } else if (window.Swiper) {
        this._swiper = new Swiper(sliderEl.querySelector('.swiper'), {
          slidesPerView: 1,
          loop: true,
          speed: 800,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }
    } catch (err) {
      console.error('[SiteMsgSlider] Swiper init failed:', err);
    }
  }

  hideForDuration(key, minutes) {
    this.style.display = 'none';
    const hideUntil = new Date(Date.now() + minutes * 60 * 1000);
    localStorage.setItem(key, hideUntil.toISOString());
  }
}

customElements.define('site-msg-slider', SiteMsgSlider);
